import PropTypes from 'prop-types'
import React from 'react'
import Alert from 'ui/Alert'
import Space from 'ui/Space'
import { space } from 'ui/variables'

const SignupAlert = props => {
  const {
    invite,
    inviteType,
    enable
  } = props

  let type = 'success'
  let message
  let title

  if (inviteType) {
    if (inviteType === 'project') {
      const project = invite
      const workspace = project.workspace
      message = <p>You have been invited to collaborate on the <strong>{project.slug}</strong> project in the <strong>{workspace.name}</strong> workspace.</p>
    } else if (inviteType === 'workspace') {
      const workspace = invite
      message = <p>You have been invited to join the <strong>{workspace.name}</strong> workspace.</p>
    }
  } else if (enable) {
    type = 'info'
    title = `Enable ${enable.integration.name}`
    message = <p>You need to sign up before we can enable this integration.</p>
  }

  if (!message) {
    return null
  }

  return (
    <div>
      <Alert type={type} title={title}>{message}</Alert>
      <Space value={space[4]} />
    </div>
  )
}

SignupAlert.propTypes = {
  invite: PropTypes.object,
  inviteType: PropTypes.string,
  enable: PropTypes.object
}

export default SignupAlert



// WEBPACK FOOTER //
// ./components/SignupAlert.js